import React from 'react';

import { H3, P } from '../../ui/headings';
import { TitleWrapper } from '../../ui/titles';
import { FlexContainer } from '../../ui/flex';
import { FitContentSectionWrapper } from '../../ui/wrappers';
import { TextWrapper } from '../../ui/about-me/about-me';

import MoreAboutMeMacWindow from './MoreAboutMeMacWindow';
import { GridContainer } from '../../ui/grid';

const AboutMe = () => (
    <FitContentSectionWrapper id='about-me'>
        <FlexContainer $column $content='center' $gap='5em'>
            <TitleWrapper>
                <H3>About me</H3>
            </TitleWrapper>
            <GridContainer $cols='1fr 1fr' $gap='5em'>
                <TextWrapper>
                    <P>
                        I am Reito. I am a bilingual full-stack software engineer in NYC. I build complex, scalable web
                        applications.
                    </P>
                    <P>
                        Growing up, I was always interested in different cultures and languages. I studied abroad in
                        Australia and the U.S. and decided to work as a sales professional in Hong Kong and Tokyo.
                    </P>
                    <P>
                        Since I immigrated to the U.S., I have thought about my career. When I was in junior high
                        school, I enjoyed coding and making a website for flip phones. Though my interests at the time
                        were cultures and languages, I didn't have a chance to study coding.
                    </P>
                    <P>
                        After I moved to NYC, I decided to pursue the dream of being a software engineer and studied
                        software engineering at Flatiron School. It was the best choice in my life. I love what I do,
                        and I am passionate about developing my skills as a software engineer.
                    </P>
                </TextWrapper>
                <MoreAboutMeMacWindow />
            </GridContainer>
        </FlexContainer>
    </FitContentSectionWrapper>
);

export default AboutMe;
